export default __webpack_public_path__ + "static/media/mansad1.1eb3e244.gif";